import { Link } from "react-router-dom";
import { categories } from "@/mocks/homeData";

export default function Footer() {
  const col1 = categories.slice(0, 5);
  const col2 = categories.slice(5, 10);
  const col3 = categories.slice(10, 14);

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-18">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-background-50/20 flex items-center justify-center">
                <i className="ri-file-list-3-line text-background-50 text-sm"></i>
              </span>
              <span className="font-heading font-semibold text-lg text-background-50">Mulebuy Sheets</span>
            </div>
            <p className="text-background-50/70 text-sm leading-relaxed max-w-sm">
              Your trusted directory for verified mulebuy spreadsheet collections. We curate the best product sourcing
              lists across fashion, electronics, shoes, accessories and trending categories — updated daily for accuracy.
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-50/15 flex items-center justify-center hover:bg-background-50/25 transition-colors cursor-pointer">
                <i className="ri-global-line text-background-50 text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-50/15 flex items-center justify-center hover:bg-background-50/25 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-background-50 text-sm"></i>
              </a>
            </div>
          </div>

          {/* Category columns */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-background-50/50 font-label font-semibold mb-5">Categories</h4>
            <ul className="space-y-3">
              {col1.map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest text-background-50/50 font-label font-semibold mb-5">More Categories</h4>
            <ul className="space-y-3">
              {col2.map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest text-background-50/50 font-label font-semibold mb-5">Resources</h4>
            <ul className="space-y-3">
              {col3.map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">
                    {cat.name}
                  </a>
                </li>
              ))}
              <li>
                <Link to="/mulebuy-spreadsheet-guide" className="text-sm text-background-50/75 hover:text-background-50 transition-colors">
                  Complete SEO Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">
                  Main Website
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background-50/15 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/50 text-xs">
            &copy; 2026 Mulebuy Spreadsheet Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-background-50/50">
            <span>Privacy Policy</span>
            <span>Terms of Service</span>
            <span>Contact</span>
          </div>
        </div>
      </div>
    </footer>
  );
}